
import { Auth, API } from "aws-amplify";
import { INQUIRY_LIST_MAX_COUNT } from "../config";

export const logout = () => {
    localStorage.clear();
};

export const getToken = async () => {
    try {
        const jwtToken = (await Auth.currentSession()).getIdToken().getJwtToken();
        return jwtToken;
    } catch {
        alert("再度ログインをお願いします。");
        logout();
        window.location.replace("/fcc_login");
        return;
    }
};

export const getUserInfo = async () => {
    const token = await getToken();
    const userId = localStorage.getItem('userId');
    localStorage.removeItem('companyId');
    localStorage.removeItem('honkenCD');
    localStorage.removeItem('userName');
    localStorage.removeItem('affiliation');
    localStorage.removeItem('companyName');
    localStorage.removeItem('isPB');
    if (token) {
        try {
            const apiName = "getUserInfo";
            const path = `getUserInfo?userId=${userId}`;
            const myInit = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "mode": "cors",
                    "Referrer-Policy": "no-referrer",
                }
            };
            const response = await API.get(apiName, path, myInit);
            if (response.result) {
                var companyId = "";
                if (response.userInfo.companyId) {
                    companyId = response.userInfo.companyId.trim();
                    if (companyId.length > 0) {
                        // Partner's Bridgeユーザ
                        localStorage.setItem('companyId', companyId);
                    }
                }
                response.userInfo.isPB = false;
                if (response.userInfo.uid) {
                    if (response.userInfo.uid.length > 0) {
                        response.userInfo.isPB = true;
                    }
                }
                localStorage.setItem('isPB', response.userInfo.isPB);
                if (companyId.length === 0) {
                    // DWPユーザは人事会社コード
                    if (response.userInfo.jinjiCD) {
                        let jinjiCD = response.userInfo.jinjiCD.trim();
                        if (jinjiCD.length > 0) {
                            localStorage.setItem('companyId', jinjiCD);
                        } else {
                            throw new Error("companyId and jinjiCD are missing");
                        }
                    } else {
                        throw new Error("companyId and jinjiCD are missing");
                    }
                }
                if (response.userInfo.honkenCD) {
                    response.userInfo.honkenCD = response.userInfo.honkenCD.trim();
                } else {
                    response.userInfo.honkenCD = '';
                }
                localStorage.setItem('honkenCD', response.userInfo.honkenCD);
                if (response.userInfo.sei) {
                    response.userInfo.sei = response.userInfo.sei.trim();
                } else {
                    response.userInfo.sei = '';
                }
                if (response.userInfo.mei) {
                    response.userInfo.mei = response.userInfo.mei.trim();
                } else {
                    response.userInfo.mei = '';
                }
                if (response.userInfo.seiYomi) {
                    response.userInfo.seiYomi = response.userInfo.seiYomi.trim();
                } else {
                    response.userInfo.seiYomi = '';
                }
                if (response.userInfo.meiYomi) {
                    response.userInfo.meiYomi = response.userInfo.meiYomi.trim();
                } else {
                    response.userInfo.meiYomi = '';
                }
                const user_name = (response.userInfo.sei + ' ' + response.userInfo.mei).trim();
                if (user_name.length > 0) {
                    localStorage.setItem('userName', user_name);
                } else {
                    localStorage.setItem('userName', '');
                }
                if (response.userInfo.departmentName) {
                    response.userInfo.departmentName = response.userInfo.departmentName.trim();
                } else {
                    response.userInfo.departmentName = "";
                }
                localStorage.setItem('affiliation', response.userInfo.departmentName);
                if (response.userInfo.companyName) {
                    response.userInfo.companyName = response.userInfo.companyName.trim();
                } else {
                    response.userInfo.companyName = "";
                }
                localStorage.setItem('companyName', response.userInfo.companyName);
                if (response.userInfo.telNo) {
                    response.userInfo.telNo = response.userInfo.telNo.trim();
                } else {
                    response.userInfo.telNo = "";
                }
                return response.userInfo;
            } else {
                throw new Error("Response Error");
            }
        } catch (err) {
            localStorage.removeItem('companyId');
            localStorage.removeItem('honkenCD');
            localStorage.removeItem('userName');
            localStorage.removeItem('affiliation');
            localStorage.removeItem('companyName');
            return false;
        }
    }

    return false;
};

//  本体＝SW/HW区分が「１」のプロダクト情報
//  OS＝SW/HW区分が「２」のプロダクト情報
//  関連HW＝SW/HW区分が「１」または「３」のプロダクト情報
//  関連SW＝SW/HW区分が「２」または「４」のプロダクト情報
export const getProductList = async (param) => {
    const token = await getToken();
    try {
        const apiName = "getProductList";
        const path = `getProductList?swhw=${param}`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            }
        };
        const response = await API.get(apiName, path, myInit);
        if (response.result) {
            return response.product;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
};


export const getModelList = async () => {
    // 本体のリスト
    return await getProductList("1");
}


export const getOsList = async () => {
    // OSのリスト
    return await getProductList("2");
}


export const getHwList = async () => {
    // 関連HWのリスト
    return await getProductList("1,3");
}


export const getSwList = async () => {
    // 関連SWのリスト
    return await getProductList("2,4");
}


export const getInquiry = async (acceptanceNumber) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    if (!acceptanceNumber) {
        return false;
    }
    try {
        const apiName = "getInquiry";
        const path = `getInquiry?userId=${userId}&acceptanceNumber=${acceptanceNumber}`;
        //const path = "getInquiry";
        // const param = {
        //     userId: userId,
        //     acceptanceNumber: acceptanceNumber
        // };
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            //    body: param
        };
        //const response = await API.post(apiName, path, myInit);
        const response = await API.get(apiName, path, myInit);
        if (response.response.result) {
            return response.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}



// POST API

/**
 * Input JSON
 * 項目名称                 項目名              型      必須
 * ユーザID                userId               String  ○
 * 会社ID                  companyId            String  ○
 * 本務兼務仮コード         tempRoleCode             String  -
 * 検索用受付番号           acceptanceNumber    String  -
 * 検索用お問い合わせ日From  acceptanceDateFrom  Date    -
 * 検索用お問い合わせ日To    acceptanceDateTo    Date    -
 * 検索用お問い合わせ状況    customerStatus      String  -
 * 検索用お客様名            customerName       String  -
 * 一覧取得開始ページ        pageNumber         Integer ○
 * １ページの取得件数        getCount           Integer ○
 * ソート項目               sortNumber         Integer ○
 * ソート順                 sortOrder          Integer ○
 */
export const getInquiryList = async (sortNumber, sortOrder, customerName = "", acceptanceNumber = "", acceptanceDateFrom = "", acceptanceDateTo = "", customerStatus = "", pageNumber = 1, getCount = INQUIRY_LIST_MAX_COUNT) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const companyId = localStorage.getItem('companyId');
    const tempRoleCode = localStorage.getItem('honkenCD');
    let param = {
        userId: userId,
        companyId: companyId,
        pageNumber: pageNumber,
        getCount: getCount,
        sortNumber: sortNumber,
        sortOrder: sortOrder,
    };
    if (tempRoleCode) {
        param.tempRoleCode = tempRoleCode;
    }
    if (acceptanceNumber !== "") {
        param.acceptanceNumber = acceptanceNumber;
    }
    if (acceptanceDateFrom !== "") {
        param.acceptanceDateFrom = acceptanceDateFrom;
    }
    if (acceptanceDateTo !== "") {
        param.acceptanceDateTo = acceptanceDateTo;
    }
    if (customerStatus !== "" && customerStatus !== "全て") {
        param.customerStatus = customerStatus;
    }
    if (customerName !== "") {
        param.customerName = customerName;
    }
    try {
        const apiName = "getInquiryList";
        const path = `getInquiryList`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        var response = await API.post(apiName, path, myInit);
        if (response.response.result) {
            if (response.response.error) {
                if (response.response.error.length > 0) {
                    const errorList = response.response.error;
                    if (errorList[0].detailCode) {
                        if (errorList[0].detailCode === "ESV0900101") {
                            response.response.allCount = INQUIRY_LIST_MAX_COUNT + 1;
                        }
                    }
                }
            }
            return response.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}


/**
 * Input JSON
 * 項目名称             項目名                      型      必須
 * ユーザID             userId                      String  〇
 * 会社ID               companyId                   String  ○
 * 本務兼務仮コード         tempRoleCode                    String  -
 * 氏名                 name                        String  ○
 * 部署名                   affiliation                 String  ○
 * 会社名                   companyName             String  ○
 * お客様名             customerName                String  -
 * モデル名(本体)           modelName                   String  〇
 * 型番                 modelNumber             String  -
 * OS名                 osName                      String  〇
 * OSバージョン         osVersion                   String  -
 * 運用形態             operationType               Integer 〇
 * 再現性・発生頻度         reappearance                Integer -
 * 件名                 subject                     String  -
 * お問い合わせ内容         body                        String  -
 * 添付資料             isAppendedDocument         Integer ○
 * 回答先メールアドレス     answerMailTo                    String  -
 * 関連ハードウェア1        relatedHardware1                String  -
 * 関連ハードウェア2        relatedHardware2                String  -
 * 関連ハードウェア型番1    relatedHardwareModelNumber1 String  -
 * 関連ハードウェア型番2    relatedHardwareModelNumber2 String  -
 * 関連ソフトウェア         relatedSoftware             String  -
 * 関連ソフトウェア型番     relatedSoftwareModelNumber  String  -
 */
export const addNewInquiry = async (modelName, osName, relatedHardware1 = "", relatedHardware2 = "", relatedSoftware = "", subject = "", body = "", answerMailTo = "", operationType, isAppendedDocument,
    customerName, modelNumber, osVersion,
    relatedHardwareModelNumber1 = "", relatedHardwareModelNumber2 = "",
    relatedSoftwareModelNumber = "", reappearance = "") => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const companyId = localStorage.getItem('companyId');
    const tempRoleCode = localStorage.getItem('honkenCD');
    const userName = localStorage.getItem('userName');
    const affiliation = localStorage.getItem('affiliation');
    const companyName = localStorage.getItem('companyName');
    let param = {
        userId: userId,
        companyId: companyId,
        name: userName,
        affiliation: affiliation,
        companyName: companyName,
        modelName: modelName,
        osName: osName,
        operationType: operationType,
        isApependedDocument: isAppendedDocument,
    };
    if (tempRoleCode) {
        param.tempRoleCode = tempRoleCode;
    }
    if (customerName !== "") {
        param.customerName = customerName;
    }
    if (modelNumber !== "") {
        param.modelNumber = modelNumber;
    }
    if (osVersion !== "") {
        param.osVersion = osVersion;
    }
    if (reappearance !== "") {
        param.reappearance = parseInt(reappearance, 10);
    }
    if (subject !== "") {
        param.subject = subject;
    }
    if (body !== "") {
        param.body = body;
    }
    if (answerMailTo !== "") {
        param.answerMailTo = answerMailTo;
    }
    if (relatedHardware1 !== "") {
        param.relatedHardware1 = relatedHardware1;
    }
    if (relatedHardware2 !== "") {
        param.relatedHardware2 = relatedHardware2;
    }
    if (relatedSoftware !== "") {
        param.relatedSoftware = relatedSoftware;
    }
    if (relatedHardwareModelNumber1 !== "") {
        param.relatedHardwareModelNumber1 = relatedHardwareModelNumber1;
    }
    if (relatedHardwareModelNumber2 !== "") {
        param.relatedHardwareModelNumber2 = relatedHardwareModelNumber2;
    }
    if (relatedSoftwareModelNumber !== "") {
        param.relatedSoftwareModelNumber = relatedSoftwareModelNumber;
    }
    try {
        const apiName = "addNewInquiry";
        const path = `addNewInquiry`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);

        if (response.response.result) {
            return response.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}

/**
 * Input JSON
 * 項目名称     項目名                  型  必須
 * ユーザID     userId              String  〇
 * 会社ID       companyId           String  ○
 * 本務兼務仮コード tempRoleCode     String  ―
 * 氏名         name                String  ○
 * 受付番号     acceptanceNumber    String  〇
 * 更新内容     body                String  〇
 * 添付資料     isAppendedDocument Integer ○
 * お問い合わせ区分 inquiryCategory     Integer ○
 */
export const addAdditionalInquiry = async (acceptanceNumber, body, isAppendedDocument, inquiryCategory) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const companyId = localStorage.getItem('companyId');
    const tempRoleCode = localStorage.getItem('honkenCD');
    const userName = localStorage.getItem('userName');
    isAppendedDocument = (isAppendedDocument != null) || (isAppendedDocument !== undefined) || (isAppendedDocument !== "") ? isAppendedDocument : 0;
    let param = {
        userId: userId,
        companyId: companyId,
        name: userName,
        acceptanceNumber: acceptanceNumber,
        body: body,
        isApependedDocument: parseInt(isAppendedDocument, 10),
        inquiryCategory: parseInt(inquiryCategory, 10),
    };
    if (tempRoleCode) {
        param.tempRoleCode = tempRoleCode;
    }
    try {
        const apiName = "addAdditionalInquiry";
        const path = `addAdditionalInquiry`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.response.result) {
            return response.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}


export const updateUserInfo = async (param) => {
    const token = await getToken();
    const userId = localStorage.getItem('userId');
    param.userId = userId;
    try {
        const apiName = "updateUserInfo";
        const path = `updateUserInfo`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.result) {
            if (param.nameInfo) {
                if (param.nameInfo.departmentName) {
                    localStorage.setItem('affiliation', param.nameInfo.departmentName);
                }
            }
            return response.result;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}

export const updateUserInfoNewsFlag = async (newsFlg) => {
    let param = {
        newsFlg: newsFlg
    }
    return await updateUserInfo(param);
};

export const updateUserInfoAgreeFlagOn = async () => {
    let param = {
        agreeFlg: 1
    }
    return await updateUserInfo(param);
};

export const updateUserInfoName = async (sei, mei, seiYomi, meiYomi, departmentName = "", telNo = "") => {
    let param = {
        nameInfo: {
            sei: sei,
            mei: mei,
            seiYomi: seiYomi,
            meiYomi: meiYomi,
            departmentName: departmentName,
            telNo: telNo
        }
    };
    return await updateUserInfo(param);
};

export const createFile = async (caseID, contactID, fileName, isConfidential, isPersonalInfo, fileSize, userName = "", companyName = "", belong = "") => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const email = (localStorage.getItem('email')).toLowerCase();
    let param = {
        userID: userId,
        caseID: caseID,
        supportID: userId,
        contactID: contactID,
        tmpFlag: false,
        caseOpenFlag: true,
        certUserID: userId,
        certMailaddress: email,
        userMailaddress: email,
        companyName: companyName,
        belong: belong,
        manualFlag: true,
        fileSize: fileSize,
        fileName: fileName,
        isConfidential: isConfidential,
        isPersonalInfo: isPersonalInfo
    };
    if (userName) {
        param.userName = userName;
        param.certUserName = userName;
    }
    try {
        const apiName = "createFile";
        const path = `createFile`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.resultInfo) {
            if (response.resultInfo.errorCode[0] === "DAMIS0000") {
                return response.resultSet;
            }
        }
    } catch (err) {
        return false;
    }
    return false;
};

export const getFileURL = async (DOC_ID, caseID, OP, UPLOAD_ID = "", PART_NUMBER = 0, PART_INFO = []) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    let param = {
        userId: userId,
        DOC_ID: DOC_ID,
        caseID: caseID,
        OP: OP
    };
    if (OP === 3) {
        param.UPLOAD_ID = UPLOAD_ID;
        param.PART_NUMBER = PART_NUMBER;
    } else if (OP === 4) {
        param.UPLOAD_ID = UPLOAD_ID;
        param.PART_INFO = PART_INFO;
    } else if (OP === 5) {
        param.UPLOAD_ID = UPLOAD_ID;
    }
    param.SOURCE = 1;  // FCC指定

    try {
        const apiName = "getFileURL";
        const path = `getFileURL`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.resultInfo) {
            if (response.resultInfo.errorCode[0] === "DAMIS0000") {
                return response.resultSet[0];
            }
        }
    } catch (err) {
        return false;
    }
    return false;
};


export const addUserInfo = async (mail) => {
    const token = await getToken();
    let param = {
        mail: mail.trim(),
    };
    try {
        const apiName = "addUserInfo";
        const path = `addUserInfo`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);

        if (response.result) {
            return response.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
};


export const getCertificateDisplay = async (contactID) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const error_html = "<html><body>サーバーが混雑しています。預り証の取得ができません。時間をおいてから再度アクセスしてください。</body></html>";
    if (!contactID) {
        return false;
    }
    try {
        const apiName = "getCertificateDisplay";
        const path = `getCertificateDisplay?userId=${userId}&caseID=DUMMY&supportID=DUMMY&contactID=${contactID}`;
        const myInit = {
            headers: {
                "Accept": "text/html",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
        };
        const response = await API.get(apiName, path, myInit);
        if (response) {
            return response;
        } else {
            return error_html;
        }
    } catch (err) {
        return error_html;
    }
};


export const controlDocInfoForPreUpload = async (caseID, contactID, userName, companyName, belong, isConfidential, isPersonalInfo) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    const email = localStorage.getItem('email');
    let param = {
        execMode: "11",
        userID: userId,
        caseID: caseID,
        supportID: userId,
        contactID: contactID,
        certUserID: userId,
        certUserName: userName,
        certMailaddress: email,
        userName: userName,
        userMailaddress: email,
        companyName: companyName,
        belong: belong,
        source: "USR",
        isConfidential: isConfidential,
        isPersonalInfo: isPersonalInfo
    };
    try {
        const apiName = "controlDocInfo";
        const path = `controlDocInfo`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.resultInfo) {
            if (response.resultInfo.errorCode[0] === "DAMIS0000") {
                return true;
            }
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
};


export const controlDocInfoForUploadDone = async (caseID, contactID, successDocIds, errorDocIds) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    let param = {
        execMode: "12",
        userID: userId,
        caseID: caseID,
        supportID: userId,
        contactID: contactID,
        source: "USR",
        successDocIds: successDocIds,
        errorDocIds: errorDocIds
    };
    try {
        const apiName = "controlDocInfo";
        const path = `controlDocInfo`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.resultInfo) {
            if (response.resultInfo.errorCode[0] === "DAMIS0000") {
                return true;
            }
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
};


export const controlDocInfoForUploadFail = async (caseID, contactID, successDocIds, errorDocIds) => {
    const token = await getToken();
    const userId = localStorage.getItem('sfUserId');
    let param = {
        execMode: "19",
        userID: userId,
        caseID: caseID,
        supportID: userId,
        contactID: contactID,
        source: "USR",
        successDocIds: successDocIds,
        errorDocIds: errorDocIds
    };
    try {
        const apiName = "controlDocInfo";
        const path = `controlDocInfo`;
        const myInit = {
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
                "mode": "cors",
                "Referrer-Policy": "no-referrer",
            },
            body: param
        };
        const response = await API.post(apiName, path, myInit);
        if (response.resultInfo) {
            if (response.resultInfo.errorCode[0] === "DAMIS0000") {
                return true;
            }
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
};